import { render, staticRenderFns } from "./dialog-leg.vue?vue&type=template&id=04698914&"
import script from "./dialog-leg.vue?vue&type=script&lang=js&"
export * from "./dialog-leg.vue?vue&type=script&lang=js&"
import style0 from "./dialog-leg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dialog-leg.vue"
export default component.exports